<template>
  <!-- 战团管理-战团成员列表 -->
  <div class="battle_user-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="query.user_name"
            placeholder="请输入用户名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.name"
            placeholder="请输入战团名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.id" placeholder="请输入战团id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 140px"
            v-model="query.status"
            placeholder="成员状态"
            @change="getData(1)"
          >
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="通过" :value="2"></el-option>
            <el-option label="拒绝" :value="3"></el-option>
            <el-option label="取消" :value="4"></el-option>
            <el-option label="解散" :value="5"></el-option>
            <el-option label="被踢" :value="6"></el-option>
            <el-option label="退出" :value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading">
        <el-table-column label="名称" align="center">
          <template slot-scope="{ row }">
            {{ row.user.name }}
          </template>
        </el-table-column>
        <el-table-column label="头像" align="center">
          <template slot-scope="{ row }">
            <img style="width: 50px" :src="row.user.avatar" alt="" />
          </template>
        </el-table-column>
        <el-table-column label="用户id" align="center">
          <template slot-scope="{ row }">
            {{ row.user.id }}
          </template>
        </el-table-column>
        <el-table-column label="所属战团" align="center">
          <template slot-scope="{ row }">
            {{ row.team.name }}
          </template>
        </el-table-column>
        <el-table-column prop="position_name" label="职位" align="center">
        </el-table-column>
        <el-table-column prop="day_exp" label="日贡献" align="center">
        </el-table-column>
        <el-table-column prop="total_exp" label="总贡献" align="center">
        </el-table-column>
        <el-table-column
          prop="total_receive"
          label="已领取总金额"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="total_receive" label="状态" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.status === 1">待审核</span>
            <span v-if="row.status === 2">通过</span>
            <span v-if="row.status === 3">拒绝</span>
            <span v-if="row.status === 4">取消</span>
            <span v-if="row.status === 5">解散</span>
            <span v-if="row.status === 6">被踢</span>
            <span v-if="row.status === 7">退出</span>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="时间" align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="200px"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-col :span="30">
              <el-button
                size="small"
                type="primary"
                @click="openApplyRecord(row)"
                >申请记录</el-button
              >
              <el-button
                size="small"
                type="danger"
                @click="openIncomeRecord(row)"
                >红包记录</el-button
              >
            </el-col>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- 申请记录 -->
    <ApplyRecord
      v-model="dialogInfos"
      :visible="applyVisible"
      @close="applyVisible = false"
    ></ApplyRecord>
    <!-- 红包记录 -->
    <IncomeRecord
      v-model="dialogInfos"
      :visible="incomeVisible"
      @close="incomeVisible = false"
    ></IncomeRecord>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import { getCookie } from '@/utils/cookie'
import ApplyRecord from '@/components/battle_groups/ApplyRecord.vue'
import IncomeRecord from '@/components/battle_groups/IncomeRecord.vue'

export default {
  name: 'battle_user',
  components: {
    ApplyRecord,
    IncomeRecord
  },
  data() {
    return {
      applyVisible: false,//申请记录显示标志
      incomeVisible: false,//红包记录显示标志
      dialogVisible: false,//弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        user_name: undefined,
        user_id: undefined,
        name: undefined,
        id: undefined,
        status: undefined
      },
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}member_card_user`
    }
  },
  created() {
    this.query.id = this.$route.query.id
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('team_user_list', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,//当前页标
            per_page: res.per_page,//每页多少条
            total: res.total,//总数据条数
            total_pages: res.total_pages,//总页数
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openApplyRecord(rowInfo) {
      //打开申请记录
      this.applyVisible = true
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
    },
    openIncomeRecord(rowInfo) {
      //打开红包记录
      this.incomeVisible = true
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.battle_user-box {
  header {
  }

  .body-box {
  }
}
</style>